import Icon from "hardcover-ui/components/Icon";
import Heading from "hardcover-ui/components/Heading";
import Text from "hardcover-ui/components/Text";
import { ReactElement } from "react";
import clsx from "clsx";

interface PageHeaderProps {
  icon?: any;
  title: string;
  description?: string;
  children?: ReactElement;
  className?: string;
  inline?: boolean;
}
export default function PageHeader({
  icon,
  title,
  description,
  children,
  inline = false,
  className = "",
}: PageHeaderProps) {
  return (
    <div
      className={clsx(
        children
          ? `${className} flex space-y-2 md:space-y-0 justify-between md:items-center`
          : "",
        children && inline ? "flex-row" : "flex-col  md:flex-row"
      )}
    >
      <div>
        <Heading size="lg" className="flex items-center ">
          {icon && <Icon icon={icon} size="xl" />}
          <span className="ml-2">{title}</span>
        </Heading>

        {description && (
          <Text as="p" variant="secondary" className="mt-2 max-w-xl">
            {description}
          </Text>
        )}
      </div>
      {children}
    </div>
  );
}
